import { render, staticRenderFns } from "./ArceList.vue?vue&type=template&id=18697e71&"
import script from "./ArceList.vue?vue&type=script&lang=js&"
export * from "./ArceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports